<template>
    <BasePanel
        :alvqa="alvqa"
        headline="lang_GENEREIC_CAPTION_PERSONS"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                hide-default-footer
                :items="persons"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
            >
                <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <!-- mouseover on headlines -->
                    <span v-if="header.mouseover !== undefined" :key="i">
                        <BaseTooltip>
                            <template v-slot:content>
                                {{ header.text }}
                                <v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon>
                            </template>
                            <template v-slot:text :alvqa="header.alvqa">
                                <span>{{ header.mouseover }}</span>
                            </template>
                        </BaseTooltip>
                    </span>
                    <span v-else :alvqa="header.alvqa" :key="header.value">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.firstName`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-first-name'">
                        {{ item.firstName }}
                    </div>
                </template>
                <template v-slot:[`item.lastName`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-last-name'">
                        {{ item.lastName }}
                    </div>
                </template>
                <template v-slot:[`item.gemaName`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-key-name'">
                        <a v-if="$alvPlugin.createUrlForAlvId(item.alvId)" :href="$alvPlugin.createUrlForAlvId(item.alvId)" target="_blank">{{ item.gemaName }}</a>
                        <span v-else>{{ item.gemaName }}</span>
                    </div>
                </template>
                <template v-slot:[`item.cellphone`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-cellphone'">
                        {{ item.cellphone }}
                    </div>
                </template>
                <template v-slot:[`item.email`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-email'">
                        {{ item.email }}
                    </div>
                </template>
                <template v-slot:[`item.role`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-role'">
                        {{ item.role }}
                    </div>
                </template>
                <template v-slot:[`item.inheritFromGroup`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-inherit-from-group'">
                        {{ item.inheritFromGroup === 'yes' ? $t('lang_GENERAL_YES') : $t('lang_GENERAL_NO') }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "PersonsReadOnlyPanel",
    components: {
        BasePanel,
        BaseTooltip
    },
    props: {
        id: {
            type: String|Number
        },
        context: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'az-persons-' + this.id + '-read-only-panel'
        }
    },
    computed: {
        persons() {
            let item = this.$store.getters['getExpanded' + this.context].find(element => {
                return element.id === this.id
            })
            return item.persons
        },
        headers() {
            return [
                {
                    text: this.$t("lang_GENERIC_CAPTION_FIRST_NAME"), 
                    align: "left", 
                    value: "firstName",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-first-name'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_LAST_NAME"), 
                    align: "left", 
                    value: "lastName",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-last-name'
                },
                {
                    text: this.$t("lang_GENERIC_AZ_CAPTION_GEMA_NAME"), 
                    align: "left", 
                    value: "gemaName",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-key-name'
                },
                {
                    text: this.$t("lang_AZ_PERSONS_CAPTION_CELLPHONE"), 
                    align: "left", 
                    value: "cellphone",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-mobil'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_EMAIL"), 
                    align: "left", 
                    value: "email",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-email'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_ROLE"), 
                    align: "left", 
                    value: "role",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-role'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_GAI"), 
                    align: "left", 
                    value: "inheritFromGroup",
                    class: 'text-no-wrap',
                    sortable: false,
                    mouseover: this.$t('lang_AZ_GROUPS_PERSONS_CAPTION_GROUP_ADDRESS_INHERITANCE'),
                    alvqa: this.alvqa + '-header-gai'
                },
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    }
}
</script>